import { createContext } from 'react';
import type { CompiledElementStyles } from './compileElementStyles';
import { renderElementStyleSheet } from './styleSheet';

// The styles a page drawn on the server wears. In a browser each element writes its rule into the page's sheet from an
// effect, and effects never run on a server; so while the server draws, each element hands its compiled rule (and the
// store its own stylesheet) to this collector instead, and the server writes them into the page's head as the very
// sheets the browser would have built, under the same marks, where the browser then finds and keeps them.

/** What one server drawing collects. */
export type ServerStyles = { rules: CompiledElementStyles[]; custom: string };

/** The collector of the drawing under way; null in a browser, where elements write their own rules. */
export const ServerStylesContext = createContext<ServerStyles | null>(null);

// Keeps what is written inside a style element from ending it.
const insideStyle = (css: string): string => css.replace(/<\/style/gi, '<\\/style');

// Writes what a drawing collected as the head's two sheets: the elements' rules, then the store's own.
export function serverStyleTags(collected: ServerStyles): string {
  const rules = renderElementStyleSheet(collected.rules);
  const custom = collected.custom.trim() ? `<style data-xshop-custom>${insideStyle(collected.custom)}</style>` : '';
  return `<style data-xshop-elements>${insideStyle(rules)}</style>${custom}`;
}
